import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withToastManager } from "react-toast-notifications";
import { faBell, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";
import { Translate, I18n } from "react-redux-i18n";
import { getXsrfToken } from "../../Store/Security/Actions";
import { addToCart as addToNopCommerceCart, updateTempCart, subscribeToBackInStock } from "../../Store/Cart/Actions";
import { goNext, onFinish } from "../../Store/Wizard/Actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { setAlertData, updateAlertModalState } from "../../Store/Modals/Actions";

class Product extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quantity: 1,
            optionClicked: {}
        };

        this.addToCart = this.addToCart.bind(this);
        this.notifyBackInStock = this.notifyBackInStock.bind(this);
        this.onQuantityChange = this.onQuantityChange.bind(this);
        this.selectOption = this.selectOption.bind(this);
    }

    componentDidMount() {
        const { product, qtyReadOnly } = this.props;

        if (qtyReadOnly) {
            document.querySelector(`#product-${product.id}-qty`).style.backgroundColor = "#eee";
            document.querySelector(`#product-${product.id}-qty`).readOnly = true;
            if (document.querySelector(".wizardDetailsQTY") && document.querySelector(".wizardDetailsQTY")) {
                document.querySelector(".wizardDetailsQTY").style.backgroundColor = "#eee";
                document.querySelector(".wizardDetailsQTY").readOnly = true;
            }
        }

        // hide the wireless plan message if on wizard
        $(".wireless-plan-message").hide();
    }

    selectOption(optionClicked) {
        this.setState({ optionClicked });
    }

    addToCart() {
        const { getXsrfToken, product, wizards, goNext, onFinish, addToNopCommerceCart, updateTempCart, wizardName, wizard, updateQuantity, filter: title, kitQuantity, deviceQuantity, getCrossSellProducts, toastManager, addToCartCb, showLoadingStatus, config: { DEVICES_CATEGORY_ID }, setCurrentId } = this.props;
        const { quantity, optionClicked } = this.state;

        if (wizard && kitQuantity === 0 || wizard && deviceQuantity === 0 || !wizard && quantity === 0) {
            alert(I18n.t("alerts.quantity"));
        } else {
            if (updateQuantity && typeof updateQuantity === "function") {
                updateQuantity(quantity);
            }

            if (wizard) {
                wizardName === "Devices" ? updateTempCart({ [title]: { [product.id]: { ...product, quantity: quantity, ...optionClicked } } }) : updateTempCart({ [title]: { [product.id]: { ...product, quantity: kitQuantity, ...optionClicked } } });

                setCurrentId(product.id);

                const { totalSteps, currentStep } = wizards[wizardName];

                // Wizard is finished at the second to last step because the last step is the Cart
                if (currentStep === totalSteps - 1) {
                    onFinish(wizardName);
                } else {
                    goNext(wizardName);
                }

                window.scrollTo(0, 0);
            } else {
                // cross sell products for wireless plan modal for devices, can be used for cross sells of other products too
                getCrossSellProducts(product);

                if (product.category.id !== DEVICES_CATEGORY_ID) {
                    toastManager.add(I18n.t("alerts.addedToCart", { quantity: quantity, name: product.name }), {
                        appearance: "success",
                        autoDismiss: true,
                        icon: faShoppingCart
                    });
                }

                getXsrfToken(({ token }) => {
                    const item = {
                        ProductId: product.id,
                        Quantity: quantity
                    };

                    if (optionClicked.productAttributeId) {
                        item.AttributeControlIds = [`product_attribute_${product.id}_${optionClicked.productAttributeId}_${optionClicked.productAttributeMapId}_${optionClicked.attributeValueId}`];
                    }

                    addToNopCommerceCart({
                        items: [item],
                        __RequestVerificationToken: token
                    }, showLoadingStatus || false, data => {
                        if (addToCartCb && typeof addToCartCb === "function") {
                            const product = _.find(data.items, i => i.productId === item.ProductId);
                            addToCartCb(product.id, quantity, product.categoryId);
                        }
                    });
                });
            }
        }
    }

    notifyBackInStock() {
        const { getXsrfToken, product, subscribeToBackInStock } = this.props;
        getXsrfToken(({ token }) => {
            const item = {
                ProductId: product.id
            };

            subscribeToBackInStock({
                items: [item],
                __RequestVerificationToken: token
            }, data => {
                    //let alertData;
                    //alertData.title = "In Stock Notification";
                    //alertData.message = data.message;               this needs to be finished to utilize alert of out of stock subscriptions
                    //setAlertData(alertData);
                    //updateAlertModalState(true);
            });
        });
    }

    onQuantityChange(quantity) {
        const { updateQuantity } = this.props;
        quantity = quantity === "" ? 0 : parseInt(quantity);

        this.setState({ quantity });

        if (updateQuantity && typeof updateQuantity === "function") {
            updateQuantity(quantity);
        }
    }

    render() {
        const { product, wizardName, wizard, wizards, label, filter, image, showDetails, title, description, productAttributes, price, discountPrice, addToCart, kitQuantity, deviceQuantity, config: { DEVICES_CATEGORY_ID }, displayStockAvailability, displayStockQuantity, stockQuantity, minStockQuantity } = this.props;
        const { quantity } = this.state;
        const className = `product ${discountPrice ? "boxed boxed--border bg--secondary h-100 d-flex flex-column" : "h-100 d-flex flex-column"}`;
        const priceClassName = `h4 inline-block ${discountPrice ? "type--strikethrough h-100" : "h-100"}`;

        return (
            <div className={`masonry__item col-md-6 col-lg-4 filter-${filter.toLowerCase()}`} data-masonry-filter={filter} >
                <div className={className}>
                    {label && <span className="label">{label}</span>}
                    <div className="product-image">
                        <img alt="Image" src={image} onClick={() => {
                            showDetails(product);
                        }} />
                    </div>
                    <div className="block">
                        <div>
                            <h5>{title}</h5>
                            <div>{description}</div>
                            <div className="product-sku"><span className="part-number"><Translate value="misc.partNumber" />: </span>{product.sku}</div>
                            {displayStockAvailability && displayStockQuantity &&
                                <div className="stock-availability"><span className="availability"><Translate value="misc.availability" />: </span>{stockQuantity > minStockQuantity ? stockQuantity : ""} <Translate value={ stockQuantity > minStockQuantity ? "misc.inStock" : "misc.outOfStock"} /></div>
                            }
                            {displayStockAvailability && !displayStockQuantity &&
                                <div className="stock-availability"><span className="availability"><Translate value="misc.availability" />: </span><Translate value={stockQuantity > minStockQuantity ? "misc.inStock" : "misc.outOfStock"} /></div>
                            }
                        </div>
                        <div>
                            <span className={priceClassName}>{price}</span>
                            {discountPrice && <span className="h4 inline-block">{discountPrice}</span>}
                        </div>
                        <div className="details-link">
                            <a onClick={() => {
                                showDetails(product);
                            }}><Translate value="misc.details" /></a>
                        </div>
                    </div>
                    {addToCart &&
                    <div className="row" style={{ marginTop: "auto" }}>
                        <div className="col-4">
                            {stockQuantity <= minStockQuantity && product.displayBackInStockSubscription ?
                                <button type="button" className="btn btn--primary" style={{ width: "100%" }} onClick={this.notifyBackInStock} data-tooltip="Notify me when available"><FontAwesomeIcon icon={faBell} /></button>
                                :
                                <input type="number" id={`product-${product.id}-qty`} placeholder={I18n.t("abbreviations.quantity").toUpperCase()} min={0} value={wizard && wizards && wizards[wizardName] && wizards[wizardName].currentStep > 1 && wizardName === "Devices" ? deviceQuantity : wizard && wizards && wizards[wizardName] && wizards[wizardName].currentStep > 1 && wizardName === "Kits" ? kitQuantity : this.state.quantity} onChange={e => this.onQuantityChange(e.target.value)} />
                            }
                        </div>
                        <div className="col-8" style={{ paddingLeft: 0 }}>
                            {productAttributes.length !== 0 && product.category.id !== DEVICES_CATEGORY_ID ?
                                <button type="button" className="btn btn--primary" style={{ width: "100%" }} disabled={stockQuantity <= minStockQuantity} onClick={() => { showDetails(product, quantity); }}><Translate value={wizard ? "misc.select" : "misc.addToCart"} /></button>
                                :
                                <button type="button" className="btn btn--primary" style={{ width: "100%" }} disabled={stockQuantity <= minStockQuantity} onClick={this.addToCart}><Translate value={wizard ? "misc.select" : "misc.addToCart"} /></button>
                            }
                        </div>
                    </div>
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        config: state.config,
        wizards: state.wizards,
        kitQuantity: state.kitQuantity,
        deviceQuantity: state.deviceQuantity
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        addToNopCommerceCart: addToNopCommerceCart,
        updateTempCart: updateTempCart,
        subscribeToBackInStock: subscribeToBackInStock,
        goNext: goNext,
        onFinish: onFinish
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withToastManager(Product));